import { call, put, takeLatest } from 'redux-saga/effects';
import routerApi from '../../api/routerApi';
import { routerActions } from './routerSlice';
import { RouteObject } from 'react-router-dom';
import { apiRoutesActions } from '../api_routes/apiRouterSlice';
import { apiNodePointsActions } from '../api_node_points/apiNodePointsSlice';

interface FetchRouteAction {
  type: string;
  payload: RouteObject;
}

function* fetchRoute(action: FetchRouteAction): Generator<any, void, any> {
  try {
    const response: any = yield call(routerApi.getRoute as any, action.payload);
    yield put(routerActions.fetchRouteSuccess(response));
  } catch (error: any) {
    yield put(routerActions.fetchRouteFailed(error));
  }
}

function* fetchGetRoutes(action: FetchRouteAction): Generator<any, void, any> {
  try {
    const response: any = yield call(routerApi.getRoutes as any, action.payload);
    yield put(apiRoutesActions.fetchGetRoutesSuccess(response));
  } catch (error: any) {
    yield put(apiRoutesActions.fetchGetRoutesFailed(error));
  }
}

function* fetchGetNodePoints(action: FetchRouteAction): Generator<any, void, any> {
  try {
    const response: any = yield call(routerApi.getNodePoints as any, action.payload);
    yield put(apiNodePointsActions.fetchGetNodePointsSuccess(response));
  } catch (error: any) {
    yield put(apiNodePointsActions.fetchGetNodePointsFailed(error));
  }
}

export default function* routerSaga(): Generator<any, void, any> {
  yield takeLatest(routerActions.fetchRoute.type, fetchRoute);
  yield takeLatest(apiRoutesActions.fetchGetRoutes.type, fetchGetRoutes);
  yield takeLatest(apiNodePointsActions.fetchGetNodePoints.type, fetchGetNodePoints);
}
